import STKIcon from "../icon";
import { formatDate } from "@/helpers/format-helpers";
import css from "./styles.module.scss";

type Props = {
    href?: string,
    download?: boolean,
    onClick?: () => void
    name?: string,
    time?: number,
    children?: JSX.Element
}

const STKPdfListItem = ( props: Props) => {
    const { href, onClick, name, time, children, download } = props;
    
    let attributes: any = {
        className: css.item
    }

    if ( href ) {
        attributes.href = href;
        attributes.target = '_blank';
        attributes.rel = 'noreferrer';
    }

    if ( download ) {
        attributes.download = true;
    }

    if ( onClick ) {
        attributes.onClick = onClick;
    }

    return(
        <a {...attributes}>
            <span className={css.item__left}>
                <STKIcon icon="pdf"/>
                <span>
                    { name }<br/>{ formatDate(time) }
                </span>
            </span>
            <span className={css.item__right}>
                {children}
            </span>
        </a>
    );

}

export default STKPdfListItem;